import FormField from '@oncolens/oncolens-ui/lib/libraries/FormField';
import TextInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextInput';
import RequestSection from '../../RequestSection';
import store from './store';

function ReferringProviderSection() {
  const formKey = 'referringProvider';

  return (
    <RequestSection title="2. Provide requesting provider contact information">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <FormField name={`${formKey}.email`} store={store}>
          {({ value, onChange, errorMessage }) => (
            <TextInput
              id="email"
              label="Requesting Provider Email"
              htmlName="email"
              placeholder="Requesting Provider Email"
              type="email"
              required={true}
              error={errorMessage}
              value={value}
              onChange={onChange}
            />
          )}
        </FormField>

        <FormField name={`${formKey}.name`} store={store}>
          {({ value, onChange, errorMessage }) => (
            <TextInput
              id="name"
              label="Requesting Provider Name"
              htmlName="name"
              placeholder="Requesting Provider name"
              type="text"
              required={true}
              error={errorMessage}
              value={value}
              onChange={onChange}
            />
          )}
        </FormField>

        <FormField name={`${formKey}.phone`} store={store}>
          {({ value, onChange, errorMessage }) => (
            <TextInput
              id="phone"
              label="Requesting Provider Phone"
              htmlName="phone"
              placeholder="123-123-1234"
              type="tel"
              required={true}
              error={errorMessage}
              value={value}
              onChange={onChange}
            />
          )}
        </FormField>
      </div>
    </RequestSection>
  );
}

export default ReferringProviderSection;
